import { NavLink } from 'react-router-dom';
import { List, ListItem } from 'material-ui/List';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Divider from 'material-ui/Divider';
import { BEHAVIOR_BLOSSOMS, VIP } from '../actions/utilAction';

class RoutesListPatientPortal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patient_id: null,
    };
    this.onModuleClick = this.onModuleClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // const history = createHistory();
    // let patient_id;
    // if ((locationArr.length > 2) && (locationArr[2]) && locationArr[2] !== 0) {
    //   patient_id = (locationArr.length > 2) ? locationArr[2] : null;
    // } else if (locationArr[2] === 0) {
    //   patient_id = (locationArr.length > 2) ? locationArr[3] : null;
    // }

    if (nextProps.patientMenuShowStatus !== undefined && nextProps.patientInfo !== undefined) {
      this.setState({ patient_id: nextProps.patientInfo.PatientID });
    } else {
      this.setState({ patient_id: null });
    }
  }

  onModuleClick(e) {
    this.props.toggleCloseMenu();
  }

  render() {
    // Parent list style
    const style = {
      padding: '12px 16px 12px 45px',
      fontSize: '15px',
    };
    // childern dropdown innerdiv styler
    return (
      <List className="nav-menu">
        {/* <ListItem
          key={100}
          primaryText="Dashboard"
          innerDivStyle={style}
          onClick={(e) => this.onModuleClick(e)}
          leftIcon={<i className="material-icons">dashboard</i>}
          containerElement={<NavLink to="/client-dashboard" exact />}
        /> */}
        <ListItem
          key={101}
          primaryText="My Profile"
          innerDivStyle={style}
          onClick={(e) => this.onModuleClick(e)}
          leftIcon={<i className="material-icons">person</i>}
          containerElement={<NavLink to={'/my-profile'} />}
        />
        <ListItem
          key={102}
          primaryText="My Appointment"
          innerDivStyle={style}
          onClick={(e) => this.onModuleClick(e)}
          leftIcon={<i className="material-icons">today</i>}
          containerElement={<NavLink to={'/my-appointment'} />}
        />
        {/* <ListItem
          key={103}
          primaryText="Mailbox"
          innerDivStyle={style}
          onClick={(e) => this.onModuleClick(e)}
          leftIcon={<i className="material-icons">contact_mail</i>}
          containerElement={<NavLink to={'/mailbox'} />}
        /> */}        
        {this.props.agencyName.toUpperCase() === BEHAVIOR_BLOSSOMS ?
          <ListItem
            key={104}
            primaryText="Bulk Signatures"
            innerDivStyle={style}
            onClick={(e) => this.onModuleClick(e)}
            leftIcon={<i className="material-icons">event_note</i>}
            containerElement={<NavLink to={'/bulk-signatures-with-signatureonly'} />}
          />        
         : 
         <ListItem
            key={104}
            primaryText="Bulk Signatures"
            innerDivStyle={style}
            onClick={(e) => this.onModuleClick(e)}
            leftIcon={<i className="material-icons">event_note</i>}
            containerElement={<NavLink to={'/bulk-signatures'} />}
          />
         }
         {this.props.loginUserInfo && this.props.loginUserInfo.isViewDataCollectionGraphs === true?
         <ListItem
            key={106}
            primaryText="Data Collection Graphs"
            innerDivStyle={style}
            onClick={(e) => this.onModuleClick(e)}
            leftIcon={<i className="material-icons">event_note</i>}
            containerElement={<NavLink to={'/datacollection-graphs'} />}
          /> : null}
          {this.props.loginUserInfo && this.props.loginUserInfo.isViewClientDocuments === true ?
         <ListItem
            key={108}
            primaryText="Documents"
            innerDivStyle={style}
            onClick={(e) => this.onModuleClick(e)}
            leftIcon={<i className="material-icons">event_note</i>}
            containerElement={<NavLink to={'/documents'} />}
          /> : null}
        <div className="menudivider">
          <Divider />
        </div>
      </List>
    );
  }
}

// export default RoutesListPatientPortal;

function mapStateToProps(state) {  
  return {
    loginUserInfo: state.login.loginUserInfo,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}

export default connect(mapStateToProps)(RoutesListPatientPortal);



// WEBPACK FOOTER //
// ./src/routers/routesListPatientPortal.js